import create from 'zustand';
import { Post } from '../services/postService';

interface DragState {
  draggedPost: Post | null;
  setDraggedPost: (post: Post | null) => void;
}

export const useDragStore = create<DragState>((set) => ({
  draggedPost: null,
  setDraggedPost: (post) => set({ draggedPost: post }),
}));
